import Reflux from 'reflux';
import BuilderActions from '../action/builderActions';

export default Reflux.createStore({
  listenables: BuilderActions,
  onPublishNewLayout: function (layout) {
    this.trigger(layout);
  },
});



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/builder/store/builderStore.js
 **/